export default "__VITE_ASSET__8ZQZjcE9__"